import React from 'react';

const SvgMenu: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 7h14M5 12h14M5 17h14" />
      </g>
    </svg>
  );
};

export default SvgMenu;
